import React from 'react';

/**
 * PageContainer Component - Wrapper for consistent page layout
 * 
 * @param {React.ReactNode} children - Page content
 * @param {string} className - Additional CSS classes
 * @param {boolean} showWatermark - Show background watermark
 */
const PageContainer = ({
    children,
    className = '',
    showWatermark = true,
    ...props
}) => {
    return (
        <div className={`min-h-screen flex flex-col items-center p-6 relative ${className}`} {...props}>
            {showWatermark && (
                <div className="watermark">
                    <img src="/fundo_pleini_pouquer.png" alt="Marca d'água" />
                </div>
            )}
            {children}
        </div>
    );
};

export default PageContainer;
